module.exports = __webpack_public_path__ + "pc/img/img_about_01.8d187417.webp";